import React, { Component } from "react";
import MarketTrends from "./MarketTrends";

import Promise from 'promise-polyfill';


export default class WidgetResidential extends Component{

constructor(props)
{
super(props);
this.state={
    data: null,
    widgetselections: [{      
        measure: "InventoryCount",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',        
      },
       {      
        measure: "AvgMonthsToSell",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      },
      {      
        measure: "SoldCount",      
        periodtype: "Quarter",
        period: "65",
        geo:["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      },
       {      
        measure: "MedSalePrice",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      },
       {      
        measure: "AvgSalePrice",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      },
       {      
        measure: "AvgSaleOverListPrice",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      },
       {      
        measure: "SoldMedDOM",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      },
       {      
        measure: "MedSalePrice,AvgSalePrice",      
        periodtype: "Quarter",
        period: "65",
        geo: ["County:San Mateo"],
        classtype: 'Residential - Single Family,Residential - Common Interest',
      }
    
  ]

}

}

  shouldComponentUpdate(nextProps, nextState) {    
    if(_.isEqual(nextProps.widgetselections, this.props.widgetselections) && !_.isEqual(nextProps.data, this.props.data)){
      return true;
    } else {
      return false;
    }
  }

  componentWillReceiveProps(nextProps) {    
    let widgetselections = this.state.widgetselections;
    let widgetselection = nextProps.widgetselections;
    let newWidgetSelections;
    
    newWidgetSelections = widgetselections.map(function(widgetinstance,index){  
      
      var _widgetSelection = widgetinstance;
      
          _widgetSelection.geo = widgetselection.geo,
          _widgetSelection.period = widgetselection.period,
          _widgetSelection.periodtype = widgetselection.periodtype

      return _widgetSelection;
      
      })   

    this.setState({ widgetselections: newWidgetSelections, data: nextProps.data });
  }

render(){
  
  let widgets = this.state.widgetselections.map((widget, index) => 
     <MarketTrends id={"chart_"+index} key={_.uniqueId("chart")} widgetselections={widget} data={this.props.data}/>
  );

return(
<div>
{widgets}
</div>

);

}
}


// WEBPACK FOOTER //
// ./src/widgetresidential.js